import { useQuery } from "@tanstack/react-query";
import fetchToBackend, { buildQuery } from "@/utils/fetchToBackend";
import { adminKeys } from "@/lib/query-keys";
import type { BidDocumentReviewReport } from "@/types/domain";
import type { ContractingErrorFilters } from "./useAdminContractingErrors";

/** Las bases que hay que arreglar a mano (panel admin). */
export function useAdminBidDocuments(filters: ContractingErrorFilters = {}) {
  return useQuery({
    queryKey: adminKeys.bidDocuments(filters),
    queryFn: () =>
      fetchToBackend<BidDocumentReviewReport[]>(
        `/admin/bid-documents${buildQuery({
          stages: filters.stages,
          publicatedFrom: filters.publicatedFrom,
          publicatedTo: filters.publicatedTo,
          sortBy: filters.sortBy,
        })}`,
      ),
  });
}
